export const PAYMENT_STATUS = {
    CREDIT: 'Credited',
    NOT_CREDITED: 'Not Credited',
    PAST_DUE: 'Past Due'

  }
  
  export const getPaymentStatusLabel = (code) => {
    return PAYMENT_STATUS[code] || code
  }